/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Contact_Emailaddress1Inputs */

const he_help_contact_emailaddress1 = /** @type {(inputs: Help_Contact_Emailaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@example.com`)
};

const en_help_contact_emailaddress1 = /** @type {(inputs: Help_Contact_Emailaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@example.com`)
};

/**
* | output |
* | --- |
* | "support@example.com" |
*
* @param {Help_Contact_Emailaddress1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_contact_emailaddress1 = /** @type {((inputs?: Help_Contact_Emailaddress1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Contact_Emailaddress1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_contact_emailaddress1(inputs)
	return en_help_contact_emailaddress1(inputs)
});
export { help_contact_emailaddress1 as "help_contact_emailAddress" }